import { getLogger } from '@openai/agents-core';
const logger = getLogger('openai-agents:realtime');
export default logger;
//# sourceMappingURL=logger.mjs.map